import prepareComponent from "@bluframe/grapple/prepareComponent";
import useUser from "hooks/useUser";
import { useHistory } from "react-router-dom";
import isTokenExpired from "./isTokenExpired";
import Route from "./Route";
const EmptyRouteComponent = (() => null);
const redirect = (history, path, onClearToken) => {
    if (onClearToken)
        onClearToken();
    history.push(path);
};
const usePrepareComponent = ({ component, exact, isAdminOnly, isEditorOnly, isLoggedInOnly, isSocialsOnly, path }) => {
    const history = useHistory();
    const { isAdmin, isEditor, isSocials, onClearToken, onGetToken } = useUser();
    const token = onGetToken();
    /**
     *  If the user is not logged in and route is only
     *  for logged in users, redirect to login page.
     */
    if (isLoggedInOnly && (!token || isTokenExpired(token))) {
        redirect(history, "/login", onClearToken);
        return { component: EmptyRouteComponent, exact, path };
    }
    /**
     *  If the user is not an admin, editor, or socials,
     * and the route is only for one of those roles,
     * redirect to home page.
     * Admins can access all routes.
     */
    if ((isAdminOnly && !isAdmin) ||
        (isEditorOnly && !isEditor && !isAdmin) ||
        (isSocialsOnly && !isSocials && !isAdmin)) {
        history.push("/");
        return { component: EmptyRouteComponent, exact, path };
    }
    return { component, exact, path };
};
export default prepareComponent(usePrepareComponent)(Route);
